import { render, staticRenderFns } from "./DocumentCategoryRegister.vue?vue&type=template&id=a366f3c4&"
import script from "./DocumentCategoryRegister.vue?vue&type=script&lang=ts&"
export * from "./DocumentCategoryRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports